import React, {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";

const STORAGE_KEY = "finance-disclaimer-dismissed";

type DisclaimerContextValue = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  closeDisclaimer: () => void;
};

const DisclaimerContext = createContext<DisclaimerContextValue | null>(null);

export const DisclaimerProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) !== "true",
  );

  const closeDisclaimer = useCallback(() => {
    sessionStorage.setItem(STORAGE_KEY, "true");
    setIsOpen(false);
  }, []);

  return (
    <DisclaimerContext.Provider value={{ isOpen, setIsOpen, closeDisclaimer }}>
      {children}
    </DisclaimerContext.Provider>
  );
};

export const useDisclaimer = () => {
  const context = useContext(DisclaimerContext);
  if (!context) {
    throw new Error("useDisclaimer must be used within DisclaimerProvider");
  }
  return context;
};
